import React, { useEffect } from 'react';
import { Calendar, ChevronDown, ChevronUp } from 'react-iconly';
import ClassicCard from './ClassicCard';
import RadioBox from './RadioBox';
import { DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

interface INoDataTableProps {
  selectedTable: string;
}

const NoDataTable: React.FC<INoDataTableProps> = ({selectedTable}) => {

    const [warining, setWarining] = React.useState<any>(null);

    useEffect(() => {
        switch (selectedTable) {
            case 'transactions':
                setWarining({
                    img: 'transactionsNoData.svg',
                    text: "You don't have any updates to your balance yet. Here you can track the details of any updates to your balance, whether you receive money or withdraw it."
                })
                break;
            case 'users':
                setWarining({
                    img: 'usersNoData.svg',
                    text: "Currently, you have not referred any users. Use the referral link above to refer users and start earning money. Here you can see all the users you have referred and check whether they are active (at least a 500$ campaign), or not."
                })
                break;
            case 'financials':
                setWarining({
                    img: 'financialNoData.svg',
                    text: "You don't have any withdrawal requests registered yet. If you want to withdraw your accumulated earnings, request a withdrawal, and here you can track the status and history of your withdrawals."
                })
                break;
            default:
                setWarining({
                    img: 'financialNoData.svg',
                    text: "You don't have any withdrawal requests registered yet. If you want to withdraw your accumulated earnings, request a withdrawal, and here you can track the status and history of your withdrawals."
                })
          }
    }, [selectedTable])

  return (
    <>
    <ClassicCard otherClasses={`p-7 m-7`}>
        <div className="w-full flex flex-row tablet:flex-col items-center justify-center py-7 relative z-50">
            {warining && (
                <div className='md:w-6/12'>
                    <img className="block mx-auto left-animation md:px-4" src={`/${warining.img}`} alt="nousers" />
                     <h1 className="text-dark-300 text-center mt-5">{warining.text}</h1>
                </div>
            )}
        </div>
    </ClassicCard>
    </>
  );
};
export default NoDataTable;
